<template>
  <v-dialog
    v-if="!!content"
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ $t('Savitarnos paslaugos naudojimosi sutartis') }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-skeleton-loader
                  v-if="contentloading"
                  type="list-item-three-line"
                ></v-skeleton-loader>
                <span v-if="!contentloading" v-html="content"></span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button
          color="danger"
          @click.native="cancel()"
          :loading="loading"
          title="Nesutinku"
        />
        <el-button
          color="primary"
          @click.native.stop="submit()"
          :loading="loading"
          title="Sutinku"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalSavitarnaAgreement',
  props: {
    value: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      content: null,
      contentloading: true,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  created() {
    if (!this.$route.query.xid) {
      this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
    }
    this.getData()
  },
  methods: {
    getData() {
      this.contentloading = true
      this.$axios
        .post(`terms`)
        .then((res) => {
          if (res) {
            this.content = res.data.html
          } else {
            this.$root.$emit('SAV_UNAUTHORIZED_ERROR')
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.contentloading = false
        })
    },
    saveConctractAgreement() {
      this.$axios
        .post(`saveTermsAgreement`)
        .then((res) => {
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
        })
    },
    submit() {
      this.$store.dispatch('userSavAgreement', true)
      this.saveConctractAgreement()
      this.closeModal()
    },
    cancel() {
      this.$emit('cancelAgreement')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
